module.exports = __webpack_public_path__ + "img/123.2747f9e3.jpg";